import React, { PureComponent, createRef } from 'react';
import cn from 'classnames';
import mojs from 'mo-js';

import styles from './Burst.less';

type BurstProps = {
  className: string;
};

const colors = [
  '#1c94bc', // elation-blue
  '#FF7900', // orange
  '#142125',
  '#1d2c32',
  '#243a41',
  '#2e4249',
  '#1c94bc', // elation-blue
  '#374e55',
  '#5b7179',
  '#74858b',
  '#FF7900', // orange
  '#8d9ca1',
  '#a8b6bb',
  '#bfccd1',
  '#cfd9dd',
  '#1c94bc', // elation-blue
  '#d7e1e5',
  '#e0e8ea',
  '#ecf1f2',
  '#f5f8f9',
  '#FF7900', // orange
];

type BurstChildProps = {
  fill: string[];
  pathScale: number[];
  degreeShift: number[];
  radius: number[];
  duration: number[];
};

const generateBurstChildProps = (numberOfItems: number): BurstChildProps =>
  Array(numberOfItems)
    .fill(0)
    .reduce(
      (props: BurstChildProps) => {
        props.fill.push(colors[Math.floor(Math.random() * colors.length)]);
        props.pathScale.push(Math.round(Math.random() * 30) / 10);
        props.degreeShift.push(Math.round(Math.random() * 360));
        props.duration.push(Math.round(Math.random() * 10 + 5) * 100);
        props.radius.push(Math.round(Math.random() * 3 + 2));

        return props;
      },
      { fill: [], pathScale: [], degreeShift: [], radius: [], duration: [] },
    );

class Burst extends PureComponent<BurstProps> {
  container: React.RefObject<HTMLDivElement> = createRef();

  componentDidMount() {
    const numberOfItems = 40;
    const burst = new mojs.Burst({
      children: {
        easing: 'quad.out',
        scale: { 1: 0, easing: 'linear.none' },
        shape: 'circle',
        ...generateBurstChildProps(numberOfItems),
      },
      count: numberOfItems,
      degree: 360,
      parent: this.container.current,
      radius: { 10: 100 },
      timeline: { delay: 0 },
    });
    burst.play();
  }

  render() {
    const { className } = this.props;
    return <div className={cn(styles.burst, className)} ref={this.container} />;
  }
}

export default Burst;
